<template>
    <section class="section">
        <h5 class="legend text-nav" v-if="legend">
            {{ legend }}
            <line-section />
        </h5>
        <slot />
    </section>
</template>

<script>
import LineSection from "@/components/LineSection";

export default {
    components: {
        LineSection,
    },
    props: {
        legend: {
            type: String,
            default: "",
        },
    },
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base

.section
    position: relative
    width: 100%
    box-sizing: border-box
    padding: calc(var(--line-base) * 3) 8.333333%

    +media('>=xsmall')
        min-height: 100vh
        padding-right: 12.5%
        padding-left: 12.5%

.legend
    display: block
    font-weight: 600
    text-transform: uppercase
    line-height: 1.5625
    width: 50%

    +media('<small')
        text-align: center
        margin: 0 auto

    +media('>=small')
        position: absolute
        top: calc(var(--line-base) * 1.5)
        left: 75%
        width: 12.5%
        margin: 0
        opacity: .75
        text-align: right

    svg
        stroke: currentColor
</style>
